import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Box, CircularProgress, Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { orderListAPI } from '../../services/api';

const DeclineDialog = ({ open, onClose, onSuccess, order }) => {
    const { t } = useTranslation();
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setReason('');
        onClose();
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await orderListAPI.decline(order._id, { declineReason: reason.trim() });
            toast.success(t('orderList.declineSuccess'));
            setReason('');
            onSuccess();
        } catch (err) {
            const msg = err.response?.data?.message || t('orderList.declineError');
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogTitle>{t('orderList.declineConfirmTitle')}</DialogTitle>

            <DialogContent dividers>
                <Box display="flex" flexDirection="column" gap={2} pt={1}>
                    <Typography variant="body2" color="text.secondary">
                        {t('orderList.orderNumber')}: <strong>{order?.orderNumber}</strong>
                    </Typography>

                    <TextField
                        label={t('orderList.declineReason')}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        size="small"
                        fullWidth
                        multiline
                        rows={3}
                        autoFocus
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>
                    {t('common.cancel')}
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleSubmit}
                    disabled={loading}
                    startIcon={loading ? <CircularProgress size={16} /> : null}
                >
                    {loading ? t('common.processing') : t('orderList.decline')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeclineDialog;